
/**
 * Module dependencies
 */
const React = require('react');
const Head = require('react-declarative-head');
const Script = require('nordic/script');
const Style = require('frontend-style');
const injectI18n = require('nordic/i18n/injectI18n');
const { ErrorScreen } = require('@andes/technical-error');
const PageContainer = require('../../../components/PageContainer');

/**
 * View Component
 */
const View = (props) => {
  const { i18n } = props;

  return (
    <PageContainer {...props} hideSearch hideSidebar state={props}>
      <div>
        <Head><title>{i18n.gettext('Mercado Pago Developers')}</title></Head>
        <Style href="error.css" />
        <Script src="error.js" priority={13} />
        <ErrorScreen
          title="Oh no, something was wrong."
          description="We already started working on fixing it."
        />
      </div>
    </PageContainer>
  );
};

module.exports = injectI18n(View);
